// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const EyeSlashRegular: React.FC<SvgProps> = (props) => (
  <Svg width="24" height="24" {...props} viewBox="0 0 24 24">
    <g
      id="グループ_900"
      data-name="グループ 900"
      transform="translate(-976 3159)"
    >
      <rect
        id="長方形_514"
        data-name="長方形 514"
        width="24"
        height="24"
        transform="translate(976 -3159)"
        fill="none"
      />
      <path
        id="eye-slash-regular"
        d="M5.45,3.262a10.049,10.049,0,0,1,6.123-2.136,10.328,10.328,0,0,1,6.965,2.834A13.623,13.623,0,0,1,21.9,8.568a1.089,1.089,0,0,1,0,.865,13.917,13.917,0,0,1-2.89,4.162l3.8,2.9a.829.829,0,0,1,.148,1.185.886.886,0,0,1-1.219.144L.333,1.508A.828.828,0,0,1,.185.323.885.885,0,0,1,1.4.18Zm1.414,1.08L8.528,5.608A4.7,4.7,0,0,1,11.573,4.5,4.566,4.566,0,0,1,16.2,9a4.373,4.373,0,0,1-.514,2.064l1.946,1.484A13.669,13.669,0,0,0,20.2,9a12.7,12.7,0,0,0-2.846-3.807,8.611,8.611,0,0,0-5.783-2.412A8.125,8.125,0,0,0,6.864,4.342Zm7.417,5.65a2.794,2.794,0,0,0,.184-1.023,2.873,2.873,0,0,0-2.893-2.812c-.025,0-.047.032-.1.032a1.319,1.319,0,0,1,.1.531,2.224,2.224,0,0,1-.239,1.027Zm.34,4.581,1.515,1.16a9.72,9.72,0,0,1-4.564,1.143,10.322,10.322,0,0,1-6.965-2.834A14.319,14.319,0,0,1,1.246,9.432a1.1,1.1,0,0,1,0-.865,13.287,13.287,0,0,1,1.759-2.89L4.369,6.722A11.231,11.231,0,0,0,2.946,8.968,12.218,12.218,0,0,0,5.79,12.807a8.585,8.585,0,0,0,5.783,2.38,7.882,7.882,0,0,0,3.049-.615Zm-7.678-5.6c0-.07,0-.169.011-.267l2.029,1.554a2.755,2.755,0,0,0,1.938,1.455L12.954,13.3a6.1,6.1,0,0,1-1.414.2A4.592,4.592,0,0,1,6.911,8.968Z"
        transform="translate(976.427 -3156)"
      />
      <path
        id="eye-regular"
        d="M5.77,39.885a4.561,4.561,0,0,1,4.616-4.506,4.507,4.507,0,1,1,0,9.011A4.561,4.561,0,0,1,5.77,39.885ZM10.385,42.7a2.817,2.817,0,1,0,0-5.632h-.1a1.373,1.373,0,0,1,.1.563,2.283,2.283,0,0,1-2.308,2.253,1.467,1.467,0,0,1-.577-.1v.07A2.857,2.857,0,0,0,10.385,42.7ZM3.441,34.837A10.273,10.273,0,0,1,10.385,32a10.277,10.277,0,0,1,6.945,2.837,13.639,13.639,0,0,1,3.35,4.615,1.1,1.1,0,0,1,0,.866,14.273,14.273,0,0,1-3.35,4.615,10.27,10.27,0,0,1-6.945,2.837,10.267,10.267,0,0,1-6.945-2.837A14.328,14.328,0,0,1,.089,40.318a1.1,1.1,0,0,1,0-.866,13.689,13.689,0,0,1,3.352-4.615Zm6.945-1.148a8.543,8.543,0,0,0-5.766,2.383,12.159,12.159,0,0,0-2.837,3.812A12.525,12.525,0,0,0,4.619,43.7a8.543,8.543,0,0,0,5.766,2.383A8.543,8.543,0,0,0,16.151,43.7a13.114,13.114,0,0,0,2.838-3.812,12.712,12.712,0,0,0-2.838-3.812,8.543,8.543,0,0,0-5.766-2.383Z"
        transform="translate(977.615 -3186.885)"
      />
    </g>
  </Svg>
);

EyeSlashRegular.displayName = 'EyeSlashRegular';

export default EyeSlashRegular;
